import {webRequest, webNoTokenRequest} from '../api'

// 房客拍表紀錄
// {
//     "contractSeq" : "CT210618000005",
//     "type" : ELECTRICITY, //WATER, ELECTRICITY, GAS
// }
export function getMeterRecord(params) {
    return webRequest({
        url:'/v1/oauth/management/contract/utility/meter/record',
        method:'get',
        params: params,
    })
}

// 批量設定通知房客拍表日期 
export function setMeterNotify(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/set/single/utilityMeter/notify/date',
        method:'post',
        data: data,
    })
}
// 上傳水電瓦斯表 
export function uploadMeter(data) {
    return webRequest({
        url:'/v1/oauth/management/contract/upload/utility/meter',
        method:'post',
        data: data,
    })
}


// WEBPACK FOOTER //
// ./src/apis/company/meterRecord.js